module.exports = __webpack_public_path__ + "static/media/isdoctorplan-general2@3x.c3f5b82a.png";